<template>
	<el-dialog
		class="modal-modify-mapping"
		:title="title"
		:visible.sync="visible"
		@close="$_cancle"
		lock-scroll
		append-to-body
		:close-on-click-modal="false"
		:close-on-press-escape="false"
	>
		<div class="content">
			<el-form
				ref="modifyMapping"
				:rules="rules"
				v-loading="isLoading"
				label-position="right"
				:model="formData"
				class="platform-modify__form"
			>
				<el-form-item label="所属运营商:" v-if="formType === 'edit'">
					<el-input
						:disabled="true"
						v-model="formData.platformName"
						style="width: 291px"
					></el-input>
				</el-form-item>

				<el-form-item label="所属品牌:" prop="brandName">
					<el-input
						:disabled="true"
						v-model="formData.brandName"
						placeholder="必选, 单选"
						style="width: 291px"
					></el-input>
					<el-button
						v-if="formType !== 'edit'"
						@click="$_selectBrand"
						class="select__btn"
						>选择</el-button
					>
				</el-form-item>

				<el-form-item label="供应商订阅名称:" prop="accessName">
					<el-input
						disabled
						v-model="formData.accessName"
						placeholder="请选择供应商订阅名称, 单选, 必选"
						style="width: 291px"
					></el-input>
					<el-button
						v-if="formType !== 'edit'"
						@click="$_selectAccess"
						class="select__btn"
						>选择</el-button
					>
				</el-form-item>

				<el-form-item label="门店:" prop="storeName">
					<el-input
						:disabled="true"
						v-model="formData.storeName"
						placeholder="必选, 单选"
						style="width: 291px"
					></el-input>
					<el-button
						v-if="formType !== 'edit'"
						@click="$_selectStore"
						class="select__btn"
						>选择</el-button
					>
				</el-form-item>

				<el-form-item label="骑手平台:" prop="sysName">
					<el-input
						:disabled="true"
						v-model="formData.sysName"
						placeholder="必选, 单选"
						style="width: 291px"
					></el-input>
					<el-button
						v-if="
							formType === 'add' ||
							(formType === 'edit' && modalData.status !== 1)
						"
						@click="$_selectSys"
						class="select__btn"
						>选择</el-button
					>
				</el-form-item>

				<el-form-item label="骑手账号标识:" prop="identifying">
					<el-select
						style="width: 200px"
						v-model="formData.identifying"
						filterable
						placeholder="请选择"
						:disabled="formType == 'edit' && modalData.status == 1"
					>
						<el-option value="default">default</el-option>
						<el-option
							v-for="item in identifyList"
							:key="item"
							:label="item"
							:value="item"
						>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="映射ID:" prop="mappingId">
					<el-input
						v-model="formData.mappingId"
						:disabled="modalData.status === 1 && formType === 'edit'"
						placeholder="必填"
						style="width: 291px"
					></el-input>
				</el-form-item>

				<el-form-item label="备注:" prop="note" type="textarea">
					<el-input
						type="textarea"
						style="width: 366px; height: 100px"
						resize="none"
						placeholder="选填"
						v-model="formData.note"
					></el-input>
					<div class="input-tips">
						*注: 如需新增门店, 请到商户管理板块中进行操作。
					</div>
				</el-form-item>
			</el-form>
		</div>

		<div slot="footer" class="dialog-footer">
			<el-button class="save__btn" @click="$_submit">保存</el-button>
			<el-button class="cancel__btn" @click="$_cancle">取消</el-button>
		</div>
		<!-- 选择品牌弹窗组件 -->
		<select-brand
			v-if="modal.show === true && modal.template === 'select-brand'"
			:title="modal.title"
			:selected="modal.data"
			@callback="$_callbackBrand"
			@close="$_close"
		></select-brand>

		<!-- 选择门店弹窗组件 -->
		<select-store
			v-if="modal.show === true && modal.template === 'select-store'"
			:title="modal.title"
			:selected="modal.data"
			:brandId="formData.brandId"
			@callback="$_callbackStore"
			@close="$_close"
		></select-store>

		<!-- 选择骑手平台弹窗组件 -->
		<select-sys
			v-if="modal.show === true && modal.template === 'select-sys'"
			:title="modal.title"
			:selected="modal.data"
			@callback="$_callbackSys"
			@close="$_close"
		></select-sys>

		<!-- 选择供应商订阅弹窗组件 -->
		<select-access
			v-if="modal.show === true && modal.template === 'select-access'"
			:title="modal.title"
			:selected="formData.accessKey"
			:accessList="modal.data"
			:showBrandName="true"
			@callback="$_callbackAccess"
			@close="$_close"
		></select-access>
	</el-dialog>
</template>
<script>
import * as Utils from '@/plugins/utils'
import SelectBrand from '@/components/modal-select-brand'
import SelectStore from '@/components/modal-select-store'
import SelectSys from './modal-select-riderCompany'
import SelectAccess from '@/components/modal-select-access'

export default {
	name: 'modal-modify-mapping',
	props: {
		title: { type: String, default: '' },
		formType: { type: String, default: 'add' },
		modalData: { type: Object, default: {} }
	},
	data() {
		return {
			visible: false,
			isLoading: false,
			identifyList: [],
			formData: {
				mid: -1,
				platformKey: '', // 根据已选品牌取值
				platformName: '', // 根据已选品牌取值
				brandId: 0, // 根据已选品牌取值
				brandName: '', // 根据已选品牌取值
				brand: {}, // 已选品牌对象
				accessKey: '',
				accessName: '',
				shopId: 0,
				storeName: '',
				storeId: '',
				sysName: '',
				sysType: '',
				mappingId: '',
				note: '', // 备注
				identifying: 'default'
			},
			modal: {
				show: false,
				title: '',
				template: '',
				data: {}
			},
			rules: {
				identifying: [{ required: true, message: '请选择标识' }],
				brandName: [{ required: true, message: '请选择品牌名称' }],
				accessName: [
					{ required: true, message: '请选择供应商订阅名称', trigger: 'blur' }
				],
				storeName: [{ required: true, message: '请选择门店', trigger: 'blur' }],
				sysName: [
					{ required: true, message: '请选择骑手平台', trigger: 'blur' }
				],
				mappingId: [
					{ required: true, message: '请填写映射ID' },
					{ validator: Utils.validID, trigger: 'blur' },
					{ validator: Utils.validCharmap, trigger: 'blur' }
				],
				note: [
					{
						validator: (rule, value, callback) => {
							if (value && value.length > 50) {
								callback(new Error('最多50个字符!'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}
				]
			}
		}
	},
	computed: {
		aid(){
			return this.$store.getters.aid||''
		}
	},
	watch: {
		'formData.brand'(val, oldVal) {
			this.formData.platformKey = val.platformKey || ''
			this.formData.platformName = val.platformName || ''
			this.formData.brandId = val.brandId || 0
			this.formData.brandName = val.brandName || ''
			if (Object.keys(oldVal).length > 0) {
				this.formData.accessKey = ''
				this.formData.accessName = ''
				this.formData.shopId = 0
				this.formData.storeId = ''
				this.formData.storeName = ''
				this.formData.identifying = ''
			}
		}
	},
	methods: {
		//缓存上一次新增的数据
		$_setLoaclData() {
			if (this.formType == 'add') {
				let { brand, shopId, storeId, storeName, accessKey, accessName } =
					this.formData
				const { platformName, platformKey, brandId, brandName } = brand || {}

				Utils.data.set('horsemanMapping'+this.aid, {
					platformName,
					platformKey,
					brandId,
					brandName,
					shopId,
					storeId,
					storeName,
					accessKey,
					accessName
				})
			}
		},
		// 获取标识
		$_getIdentify() {
			const { sysType, accessKey, shopId } = this.formData
			if (sysType && accessKey && shopId) {
				this.$service
					.post('getConfigIdentify', {
						deliverySysType: sysType,
						accessKey,
						shopId
					})
					.then(result => {
						this.isLoading = false
						if (result.$.checkResult(result, true)) {
							this.identifyList = result.data
						}
					})
			} else {
				this.identifyList = []
			}
		},
		// 选择品牌
		$_selectBrand() {
			// 处理已选择的品牌数据
			this.modal.data = {
				brandId: this.formData.brandId,
				brandName: this.formData.brandName
			}
			this.modal.title = '选择品牌'
			this.modal.template = 'select-brand'
			this.modal.show = true
		},
		// 选择品牌回调
		$_callbackBrand(data) {
			this.formData.brand = { ...data }
			this.$refs['modifyMapping'].validateField('brandName')

			this.$_setLoaclData()
		},
		// 选择供应商订阅
		async $_selectAccess() {
			if (this.formData.brandId === 0) {
				$MessageBox.alert({ content: '请选择品牌' })
				return false
			}
			await this.$service
				.post('findSubscribeByPlatform', {
					platformKey: this.formData.platformKey
				})
				.then(result => {
					this.isLoading = false
					if (result.$.checkResult(result, true)) {
						this.modal.data = result.data.reduce((prev, next) => {
							const list =
								next.accessList.map(item => {
									item.brandName = next.brandName
									return item
								}) || []
							return prev.concat(list)
						}, [])
					}
				})
			this.modal.title = '选择供应商订阅名称'
			this.modal.template = 'select-access'
			this.modal.show = true
		},
		// 选择供应商订阅回调
		$_callbackAccess(data) {
			this.formData.accessKey = data.accessKey
			this.formData.accessName = data.accessName
			this.$refs['modifyMapping'].validateField('accessName')
			//获取标识
			this.formData.identifying = ''
			this.$_getIdentify()

			this.$_setLoaclData()
		},
		// 选择门店
		$_selectStore() {
			if (!this.formData.brandId) {
				$MessageBox.alert({ content: '请选择品牌!' })
				return false
			}
			this.modal.data = {
				shopId: this.formData.shopId,
				storeId: this.formData.storeId,
				storeName: this.formData.storeName
			}
			this.modal.title = '选择门店'
			this.modal.template = 'select-store'
			this.modal.show = true
		},
		// 选择门店回调
		$_callbackStore(data) {
			let { shopId, storeName, storeId } = data
			this.formData.shopId = shopId
			this.formData.storeId = storeId
			this.formData.storeName = storeName
			this.$refs['modifyMapping'].validateField('storeName')
			//获取标识
			this.formData.identifying = ''
			this.$_getIdentify()

			this.$_setLoaclData()
		},
		// 选择骑手平台
		$_selectSys() {
			this.modal.data = {
				sysType: this.formData.sysType,
				sysName: this.formData.sysName
			}
			this.modal.title = '选择骑手平台'
			this.modal.template = 'select-sys'
			this.modal.show = true
		},
		// 选择骑手平台回调
		$_callbackSys(data) {
			let { deliverySysType, deliverySysName } = data
			this.formData.sysType = deliverySysType
			this.formData.sysName = deliverySysName
			this.$refs['modifyMapping'].validateField('sysName')
			//获取标识
			this.formData.identifying = ''
			this.$_getIdentify()
		},
		// 关闭选择品牌
		$_close() {
			this.modal.show = false
			this.modal.template = ''
			this.modal.title = ''
			this.modal.data = {}
		},
		$_submit() {
			if (this.isLoading) return false
			this.$refs['modifyMapping'].validate(valid => {
				if (valid) {
					const self = this
					self.isLoading = true
					let action = 'addMapping'
					let postData = {
						type: 1,
						platformKey: self.formData.platformKey,
						brandId: self.formData.brandId,
						accessKey: self.formData.accessKey,
						shopId: self.formData.shopId,
						mappingId: self.formData.mappingId,
						sysType: self.formData.sysType,
						note: self.formData.note,
						identifying: self.formData.identifying
					}
					if (self.formType === 'edit') {
						action = 'editMapping'
						Object.assign(postData, {
							mid: self.formData.mid
						})
					}

					self.$service.post(action, postData).then(result => {
						self.isLoading = false
						if (result.$.checkResult(result, true)) {
							$MessageBox.alert({
								content: result.msg,
								onOk() {
									self.visible = false
									self.$emit('callback')
								}
							})
						}
					})
				}
			})
		},

		$_cancle() {
			this.visible = false
			this.$emit('close')
		}
	},
	created() {
		if (this.formType === 'edit') {
			let {
				mid,
				platformKey,
				platformName,
				brandId,
				brandName,
				accessKey,
				accessName,
				shopId,
				storeId,
				storeName,
				sysName,
				sysType,
				mappingId,
				note,
				identifying
			} = this.modalData
			this.formData.mid = mid
			this.formData.brand = {
				platformKey,
				platformName,
				brandId,
				brandName
			}
			this.formData.accessKey = accessKey
			this.formData.accessName = accessName
			this.formData.shopId = shopId
			this.formData.storeId = storeId
			this.formData.storeName = storeName
			this.formData.sysName = sysName
			this.formData.sysType = sysType
			this.formData.mappingId = mappingId
			this.formData.note = note
			this.formData.identifying = identifying || 'default'
			//获取标识
			this.$_getIdentify()
		} else {
			const {
				platformKey,
				platformName,
				accessKey,
				accessName,
				brandId,
				brandName,
				storeId,
				storeName,
				shopId
			} = Utils.data.get('horsemanMapping'+this.aid) || {}
			this.formData.brand = {
				platformKey: platformKey || '',
				platformName: platformName || '',
				brandId: brandId || 0,
				brandName: brandName || ''
			}
			this.formData.storeId = storeId || ''
			this.formData.storeName = storeName || ''
			this.formData.accessKey = accessKey || ''
			this.formData.accessName = accessName || ''
			this.formData.shopId = shopId || 0
		}
	},
	mounted() {
		this.visible = true
	},
	components: {
		SelectBrand,
		SelectStore,
		SelectSys,
		SelectAccess
	}
}
</script>

<style lang="scss" scoped>
.platform-modify__form {
	padding: {
		left: 20px;
	}
}
.content {
	height: 100%;
	padding: 20px 20px;
	.title {
		height: 32px;
		color: #384e8c;
		font-size: 14px;
		font-weight: 700;
	}
}
.select__btn {
	margin-left: 8px;
}
.input-tips {
	margin-left: 10px;
}
</style>
